import React from 'react'
import Layout from 'components/LayoutForPortal'
const Index = () => {
    return (
        <Layout>
            settings component
        </Layout>
    )
}

export default Index
